import { render } from "./AddOns.vue?vue&type=template&id=316802e0"
import script from "./AddOns.vue?vue&type=script&lang=js"
export * from "./AddOns.vue?vue&type=script&lang=js"
script.render = render

export default script

/* vue-cli-plugin-import-components */
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import PageTitle from "@/components/PageTitle.vue";
import AddOnList from "@/components/AddOnList.vue";
script.components = Object.assign({}, { Breadcrumbs, PageTitle, AddOnList }, script.components);